interface LogoProps {
  variant?: "dark" | "light";
  className?: string;
}

/** The Maayad Admin wordmark: logo image + serif name + "Admin" badge. */
export default function Logo({ variant = "dark", className = "" }: LogoProps) {
  const nameColor = variant === "light" ? "text-white" : "text-navy-900";

  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <img src="/logo .png" alt="Maayad" className="h-9 w-9 shrink-0 object-contain" />
      <div className="leading-none">
        <span className={`block font-display text-2xl font-bold ${nameColor}`}>Maayad</span>
        <span className="mt-0.5 block text-[10px] font-medium uppercase tracking-wide text-gold-500">
          Admin
        </span>
      </div>
    </span>
  );
}
